export default "__VITE_ASSET__i_PF9ZgE__"